import Drawer from 'components/Drawer'
import {
  AcceptOrRejectFlex,
  AcceptTextArea,
  CancelButton,
  ConfirmButton,
  ErrorMessage,
  FooterFlex,
  RadioBtnDiv,
  RadioBtnSpan,
  RadioGroup,
  RejectResonDiv,
  RejectStyledRadio,
  StartSpan,
  StyledRadio,
} from 'modules/Roles/Partials/ViewIndividualRole/AcceptOrRejectDrawer/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import rolesApi from 'utils/corporateRequest'
import SuccessMessage from '../../../../../utils/SuccessMessage'

const AcceptDrawer = ({
  newAcceptOrRejectDrawer,
  setnewAcceptOrRejectDrawer,
  instituteCampusId,
  jobId,
  roleStatus,
  eventId,
  selectedRole,
  sendNotificationEmail,
  roleaccpectTemplate,
  rolerejectTemplate,
  getUserCorpList,
  sendNotificationBulkEmail,
}) => {
  const [status, setStatus] = useState('')
  const [rejectedReason, setRejectedReason] = useState('')
  const [otherReason, setOtherReason] = useState('')
  const [showErrorMsg, setShowErrorMsg] = useState(false)
  const [showOtherReason, setShowOtherReason] = useState(false)
  const [corporateEmailList, setCorporateEmailList] = useState([])
  const institute = useSelector(state => state.auth.instituteDetails)
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (selectedRole?.jobRoles?.corporate?.id) {
        let responce = await getUserCorpList(
          selectedRole?.jobRoles?.corporate?.id
        )
        setCorporateEmailList(responce)
      }
    })()

    return () => {}
  }, [selectedRole])

  const onChangeOption = e => {
    setStatus(e.target.value)
    if (e.target.value === '1') {
      setShowErrorMsg(false)
    }
  }
  const onRejectChange = e => {
    setRejectedReason(e.target.value)
    if (e.target.value === 'OTHER') {
      setShowOtherReason(true)
    } else {
      setShowOtherReason(false)
      setShowErrorMsg(false)
    }
  }
  const onConfirm = () => {
    if (!status) {
      setShowError(true)
      hasError = true
    }
    if (!status) return
    let payLoad = {}
    if (status == '1') {
      payLoad.status = 1
    } else {
      payLoad.status = -1
      if (!otherReason && !rejectedReason) {
        setShowErrorMsg(true)
        return
      }
      if (rejectedReason) {
        payLoad.rejectedReason = rejectedReason
        if (rejectedReason === 'OTHER') {
          if (otherReason) {
            payLoad.otherReason = otherReason
          } else {
            setShowErrorMsg(true)
            return
          }
        }
      }
    }
    acceptOrReject(payLoad)
  }
  const acceptOrReject = async payLoad => {
    let eventIdQuery = eventId ? `?eventId=${eventId}` : ''
    try {
      const info = await rolesApi.post(
        `/corporates/jobs/${jobId}/jobsByInstitute/${instituteCampusId}/updateStatus${eventIdQuery}`,
        payLoad
      )
      if (info?.status >= 200 && info?.status) {
        if (payLoad?.status === 1 && roleaccpectTemplate) {
          const final = corporateEmailList?.list?.map(item => {
            let name = item?.first_name + ' ' + item?.last_name
            const currentDate = moment().format('DD MMM YYYY')
            const template = roleaccpectTemplate?.templateText
              .replace('{UserName}', name)
              .replace('{institutionname}', institute?.campusName)
              .replace('{roleName}', selectedRole?.jobRoles?.tittle)
              .replace('{dd/mmm/yyyy}', currentDate)
            return {
              to: item?.email,
              subject:
                roleaccpectTemplate?.subject ||
                'Role Accepted Notification - Pluginlive',
              htmlBody: template,
            }
          })
          sendNotificationBulkEmail(final)
        }
        if (payLoad?.status === -1 && rolerejectTemplate) {
          const final = corporateEmailList?.list?.map(item => {
            let name = item?.first_name + ' ' + item?.last_name
            const currentDate = moment().format('DD MMM YYYY')
            const template = rolerejectTemplate?.templateText
              .replace('{UserName}', name)
              .replace('{institutionname}', institute?.campusName)
              .replace('{roleName}', selectedRole?.jobRoles?.tittle)
              .replace('{dd/mmm/yyyy}', currentDate)
            return {
              to: item?.email,
              subject:
                rolerejectTemplate?.subject ||
                'Role Rejected Notification - Pluginlive',
              htmlBody: template,
            }
          })
          sendNotificationBulkEmail(final)
        }
      }
      setnewAcceptOrRejectDrawer(false)
      SuccessMessage(info.data.message)
    } catch (error) {}
  }
  const content = () => {
    return (
      <Fragment>
        <RadioGroup onChange={onChangeOption}>
          <StyledRadio
            boxed={true}
            value={'1'}
            disabled={roleStatus === 1}
            label={
              <AcceptOrRejectFlex>
                <div>
                  <RadioBtnSpan>Accept Role</RadioBtnSpan>
                  <RadioBtnDiv>
                    Once you accept the role,all eligible candidates will get
                    this job/role alert
                  </RadioBtnDiv>
                </div>
              </AcceptOrRejectFlex>
            }
          />
          <StyledRadio
            boxed={true}
            value={'-1'}
            disabled={roleStatus === -1}
            label={
              <AcceptOrRejectFlex>
                <div>
                  <RadioBtnSpan>Reject Role</RadioBtnSpan>
                  <RadioBtnDiv>
                    If you are not interested,reject the role
                  </RadioBtnDiv>
                </div>
              </AcceptOrRejectFlex>
            }
          />
          {showErrorMsg && (
            <ErrorMessage>
              Select Reason for Reject or Enter Reason
            </ErrorMessage>
          )}

          {showError && (
            <ErrorMessage>
              Kindly select accept/reject to confirm the role.
            </ErrorMessage>
          )}
        </RadioGroup>
        {status === '-1' && (
          <>
            <RejectResonDiv>
              Reason <StartSpan>*</StartSpan>
            </RejectResonDiv>
            <RadioGroup onChange={onRejectChange}>
              <RejectStyledRadio
                boxed={true}
                value={'SALARY_LOW'}
                label={<RadioBtnSpan>Salary is low</RadioBtnSpan>}
              />
              <RejectStyledRadio
                boxed={true}
                value={'LOCATION_FAR'}
                label={<RadioBtnSpan>Job Location is far</RadioBtnSpan>}
              />
              <RejectStyledRadio
                boxed={true}
                value={'NOT_INTRESTED_CORPORATE'}
                label={
                  <RadioBtnSpan>Not interested in this company</RadioBtnSpan>
                }
              />
              <RejectStyledRadio
                boxed={true}
                value={'OTHER'}
                label={<RadioBtnSpan>Other Reason</RadioBtnSpan>}
              />
            </RadioGroup>
            {showOtherReason && (
              <Fragment>
                <RejectResonDiv>
                  Other reason <StartSpan>*</StartSpan>
                </RejectResonDiv>
                <AcceptTextArea
                  onChange={e => {
                    setOtherReason(e.target.value)
                  }}
                  placeholder={'Please enter the reason to reject this role'}
                />
              </Fragment>
            )}
          </>
        )}
      </Fragment>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <CancelButton
          text={'Cancel'}
          onClick={() => setnewAcceptOrRejectDrawer(false)}
        />
        <ConfirmButton onClick={onConfirm} text={'Confirm'} />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="40%"
      title={'Accept/Reject Role'}
      placement="right"
      closable={true}
      onClose={() => setnewAcceptOrRejectDrawer(false)}
      visible={newAcceptOrRejectDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default AcceptDrawer
